module.exports = __webpack_public_path__ + "files/52021d6b4bd603a466bd0b4ff0814f1e.png";